import { CSSProperties } from 'react';
import cn from 'classnames';

import { EChipsSelectMenuPlacement } from '@components/common/GroupSelect/enum';

import { InvisibleItemsPosition } from '@interfaces/invisibleItems';
import { TChipsSelectMenuPlacementValues } from '@components/common/GroupSelect/GroupSelect.types';

export const DEFAULT_POSITION = {
	top: 0,
	left: 0,
	width: 0,
	height: 0,
};

export const MAX_WIDTH = 360;
export const MAX_HEIGHT = 360;
export const PADDING_WIDTH = 10;

export const getInvisibleItemsClassName = (menuPlacement: TChipsSelectMenuPlacementValues): string => {
	return cn('f5gInvisibleItemsWrapper', {
		'f5gInvisibleItemsTopEnd': menuPlacement === EChipsSelectMenuPlacement.topEnd,
		'f5gInvisibleItemsBottomEnd': menuPlacement === EChipsSelectMenuPlacement.bottomEnd,
		'f5gInvisibleItemsTop': menuPlacement === EChipsSelectMenuPlacement.top,
		'f5gInvisibleItemsBottom': menuPlacement === EChipsSelectMenuPlacement.bottom,
	});
};

export const getInvisibleItemsStyles = (
	usePortal: boolean,
	position: InvisibleItemsPosition,
	maxHeight: number,
): CSSProperties => {
	if (usePortal) {
		return {
			position: 'absolute',
			top: position.top,
			left: position.left,
			maxHeight: `${maxHeight}px`,
			zIndex: 9999,
		};
	}

	return {
		maxHeight: `${maxHeight}px`,
	};
};
